import { useState } from "react";
import { RefreshCw, X, Loader2, BookOpen } from "lucide-react";
import { usePWA } from "../lib/usePWA";
import { useAuth } from "@shared/lib/auth";
import { GuideModal } from "@shared/components/GuideModal";

export function PWAUpdatePrompt() {
  const { needRefresh, isUpdating, applyUpdate, dismissUpdatePrompt } =
    usePWA();
  const { user } = useAuth();
  const [guideOpen, setGuideOpen] = useState(false);

  if (needRefresh) {
    return (
      <div className="fixed bottom-20 left-4 right-4 z-40 mx-auto max-w-md sm:left-auto sm:right-6">
        <div className="rounded-lg bg-surface/90 p-5 shadow-soft backdrop-blur-xl">
          <div className="flex items-start gap-4">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-accent/10">
              <RefreshCw className="h-5 w-5 text-accent" />
            </div>
            <div className="flex-1">
              <h3 className="font-display text-base font-medium tracking-tight text-foreground">
                Update available
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-muted">
                A new version of cradleOS is ready to install.
              </p>
              <div className="mt-4 flex items-center gap-3">
                <button
                  onClick={applyUpdate}
                  disabled={isUpdating}
                  className="flex items-center gap-2 rounded-xl bg-accent px-4 py-2 text-sm font-semibold text-accent-foreground transition-all duration-200 ease-out hover:-translate-y-0.5 hover:brightness-110 hover:shadow-md disabled:opacity-60"
                >
                  {isUpdating ? (
                    <>
                      <Loader2 className="h-4 w-4 animate-spin" />
                      Refreshing...
                    </>
                  ) : (
                    "Refresh now"
                  )}
                </button>
                <button
                  onClick={dismissUpdatePrompt}
                  className="rounded-xl px-4 py-2 text-sm font-medium text-muted transition-colors hover:bg-foreground/5"
                >
                  Later
                </button>
              </div>
            </div>
            <button
              onClick={dismissUpdatePrompt}
              className="flex-shrink-0 rounded-lg p-1.5 text-muted transition-colors hover:bg-foreground/5 hover:text-foreground"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!user) return null;

  return (
    <>
      <div className="fixed bottom-2 left-0 right-0 z-30 flex justify-center pointer-events-none">
        <button
          onClick={() => setGuideOpen(true)}
          className="pointer-events-auto flex items-center gap-1.5 text-xs text-muted/60 transition-colors hover:text-muted"
        >
          <BookOpen className="h-3 w-3" />
          Guide
        </button>
      </div>
      <GuideModal isOpen={guideOpen} onClose={() => setGuideOpen(false)} />
    </>
  );
}
